module.exports = __webpack_public_path__ + "img/variable_in_new_tab.8b82d191.png";